const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api';

async function request(path, options = {}) {
  const token = localStorage.getItem('adminToken');
  const headers = {
    'Content-Type': 'application/json',
    ...options.headers,
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await fetch(`${API_BASE_URL}${path}`, {
    ...options,
    headers,
  });

  const text = await response.text();
  let data = {};

  if (text) {
    try {
      data = JSON.parse(text);
    } catch (err) {
      data = {
        message: response.ok ? 'Invalid server response' : 'Server is unavailable',
      };
    }
  }

  if (!response.ok) {
    throw new Error(data.message || `Request failed with status ${response.status}`);
  }

  return { data };
}

const post = (path, body) =>
  request(path, {
    method: 'POST',
    body: JSON.stringify(body),
  });

const put = (path, body) =>
  request(path, {
    method: 'PUT',
    body: JSON.stringify(body),
  });

const del = (path, body) =>
  request(path, {
    method: 'DELETE',
    body: JSON.stringify(body),
  });

// Auth API
export const authAPI = {
  login: (email, password) => post('/auth/login.php', { email, password }),

  logout: () => post('/auth/logout.php', {}),

  requestPasswordReset: (email) => post('/auth/request-reset.php', { email }),

  resetPassword: (token, password) => post('/auth/reset-password.php', { token, password }),
};

// Submissions API
export const submissionsAPI = {
  create: (data) => post('/submissions/create.php', data),

  list: () => request('/submissions/list.php'),

  update: (id, status) => put('/submissions/update.php', { id, status }),

  delete: (id) => del('/submissions/delete.php', { id }),

  search: (query) => request(`/submissions/search.php?q=${encodeURIComponent(query)}`),
};

const api = { request, post, put, del };

export default api;
